import { en } from './en'
import { fr } from './fr'

export const employeesPage = {
  en,
  fr
}